/**
  * Automatic generated for gulp
  * params hostings generalapp
	* params hostings personalapp
  */
 import { hostings } from './hostings';
 export const env = {...hostings.personalapp, version: '1.0.9'};
 